import Container from '@mui/material/Container'
import Divider from '@mui/material/Divider'
import Typography from '@mui/material/Typography'

import Navbar from '../components/navbar'
import NavbarFooter from '../components/navbar/NavbarFooter'

export default function DataDeletionPage() {
    return (
        <>
            <Navbar />
            <section>
                <main>
                    <Container sx={{ mt: 4, maxWidth: 'md' }}>
                        <Typography variant="h3" gutterBottom>Data Deletion Instructions</Typography>
                        <Typography variant="body1" sx={{ mb: 2 }}>
                            If you signed in to CrapApp using Facebook and would like your personal data removed,
                            you have two options. Both result in the same outcome: all personal information linked
                            to your account is permanently deleted.
                        </Typography>

                        <Divider sx={{ my: 3 }} />

                        <Typography variant="h5" sx={{ fontWeight: 'bold' }} gutterBottom>Option 1 — Delete Your Account In-App (Immediate)</Typography>
                        <Typography variant="body1" sx={{ mb: 1 }}>
                            The fastest way to remove your data is to delete your account directly inside CrapApp:
                        </Typography>
                        <Typography variant="body1" component="ol" sx={{ mb: 2, pl: 3 }}>
                            <li>Log in to CrapApp.</li>
                            <li>Open the <strong>Profile</strong> page from the navigation menu.</li>
                            <li>Scroll to the bottom and select <strong>Delete Account</strong>.</li>
                            <li>Confirm the deletion when prompted.</li>
                        </Typography>
                        <Typography variant="body1" sx={{ mb: 2 }}>
                            Deletion is immediate. Your account, email address, display name, Facebook login
                            association, and IP address logs are all permanently removed the moment you confirm.
                        </Typography>

                        <Divider sx={{ my: 3 }} />

                        <Typography variant="h5" sx={{ fontWeight: 'bold' }} gutterBottom>Option 2 — Email Request (Processed Within 30 Days)</Typography>
                        <Typography variant="body1" sx={{ mb: 2 }}>
                            If you can no longer access your account, send an email to{' '}
                            <a href="mailto:admin@crapapp.live?subject=Data%20Deletion%20Request">admin@crapapp.live</a>{' '}
                            with the subject line <strong>Data Deletion Request</strong>. Include the email address
                            associated with your CrapApp account so we can locate your data. We will process your
                            request and confirm deletion within 30 days.
                        </Typography>

                        <Divider sx={{ my: 3 }} />

                        <Typography variant="h5" sx={{ fontWeight: 'bold' }} gutterBottom>What Gets Deleted</Typography>
                        <Typography variant="body1" component="ul" sx={{ mb: 2, pl: 3 }}>
                            <li>Your email address</li>
                            <li>Your display name</li>
                            <li>Your Facebook login association (OAuth provider ID)</li>
                            <li>IP address logs tied to your account</li>
                        </Typography>

                        <Typography variant="h5" sx={{ fontWeight: 'bold' }} gutterBottom>What Gets Kept (Anonymized)</Typography>
                        <Typography variant="body1" sx={{ mb: 2 }}>
                            The minimum-bet reports you submitted are part of the crowd-sourced dataset that other
                            players rely on. After your account is deleted, those reports are kept but fully
                            anonymized — they are permanently disassociated from your identity and cannot be
                            traced back to you in any way.
                        </Typography>

                        <Divider sx={{ my: 3 }} />

                        <Typography variant="body2" color="text.secondary" sx={{ mb: 4 }}>
                            For any other privacy questions, see our{' '}
                            <a href="/privacy">Privacy Policy</a> or contact us at{' '}
                            <a href="mailto:admin@crapapp.live">admin@crapapp.live</a>.
                        </Typography>
                    </Container>
                </main>
            </section>
            <NavbarFooter />
        </>
    )
}
